module.exports = __webpack_public_path__ + "static/media/slider-link.fb2a2484.svg";